var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHiking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7748 4.5C12.7748 5.88071 11.6275 7 10.2122 7C8.79692 7 7.64962 5.88071 7.64962 4.5C7.64962 3.11929 8.79692 2 10.2122 2C11.6275 2 12.7748 3.11929 12.7748 4.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24934 7.93935L9.78761 8.46448C11.1236 9.76781 12.9355 10.5 14.8248 10.5C14.9121 10.5 14.9977 10.5071 15.0811 10.5207V9.00001C15.0811 8.5858 15.4253 8.25001 15.8498 8.25001C16.2744 8.25001 16.6186 8.5858 16.6186 9.00001V16.8375L20.6364 15.4656C21.3028 15.2381 22 15.7206 22 16.4095V22H2.10261C1.9872 22 1.95982 21.8428 2.06874 21.8056L3.74522 21.2332C3.44306 20.7066 3.48626 20.031 3.90588 19.5397C5.3314 17.8709 6.11208 15.7672 6.11208 13.5949V13.5C6.11208 12.0711 6.25675 10.6458 6.54399 9.24467L6.65445 8.70584C6.76566 8.16339 7.17387 7.72468 7.71658 7.56437C8.25929 7.40407 8.84838 7.54818 9.24934 7.93935ZM15.0811 13.4793C14.9977 13.4929 14.9121 13.5 14.8248 13.5C12.8334 13.5 10.9021 12.9318 9.25856 11.8875C9.23517 12.1512 9.21751 12.4154 9.20561 12.6799L9.52235 12.873C11.4295 14.0359 12.7271 15.9124 13.1433 18.0242L15.0811 17.3625V13.4793ZM10.189 19.0329C10.0837 17.9775 9.62448 16.9925 8.89514 16.2254C8.5953 17.5599 8.06889 18.8384 7.33596 20.0071L10.189 19.0329Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiking);
export default __webpack_public_path__ + "static/media/hiking.91f33fb14da9eb5bda09f38c8fb3aa5f.svg";
export { ForwardRef as ReactComponent };